import React from "react";
import "./OrderStatCard.css";

const OrderStatCard = ({
  title,
  value,
  bgGradient,
  icon: Icon,
}) => {
  return (
    <div
      className="order-stat-card position-relative overflow-hidden h-100"
      style={{ background: bgGradient }}
    >
      <div className="order-stat-circle"></div>

      <div className="card-body px-3 py-3 position-relative">
        <div className="d-flex align-items-center">
          <div className="order-stat-icon">
            <Icon size={24} color="#fff" strokeWidth={2} />
          </div>

          <div className="order-stat-content ms-3">
            <h6 className="order-stat-title">{title}</h6>
            <h3 className="order-stat-value">{value}</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderStatCard;